<template>
  <!--  更多信息  抽取公共组件  -->
  <div class="m-load-more">
    <el-button type="text" @click="loadMore" :loading="loading">
      <span v-if="last">{{ $t('commons.MoreInfo.last') }}</span>
      <span v-else-if="loading">{{ $t('commons.MoreInfo.loading') }}</span>
      <span v-else>{{ $t('commons.MoreInfo.more') }}</span>
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    last: {
      type: [Boolean, Number],
      required: true,
    },
  },
  methods: {
    loadMore() {
      if (this.last) {
        this.$message(this.$t('commons.MoreInfo.noneMessage'))
        return
      }
      this.$emit('LoadMore')
    },
  },
}
</script>
<style lang="scss" scoped>
.m-load-more {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>

 